export const packagingList = [
  { id: 'NotUnPackaging', name: 'Custom Packaging' },
  { id: '_1G', name: 'Fibre Drum (1G)' },
  { id: '_4G', name: 'Fibreboard Box (4G)' },
  { id: '_1N1', name: 'Metal Drum non-removable head (1N1)' },
  { id: '_1N2', name: 'Metal Drum removable head (1N2)' },
  { id: '_5M1', name: 'Paper Bag multiwall (5M1)' },
  { id: '_5M2', name: 'Paper Bag multiwall, water-resistant (5M2)' },
  { id: '_1H1', name: 'Plastic Drum non-removable head (1H1)' },
  { id: '_1H2', name: 'Plastic Drum removable head (1H2)' },
  { id: '_3H1', name: 'Plastic Jerrican non-removable head (3H1)' },
  { id: '_3H2', name: 'Plastic Jerrican removable head (3H2)' },
  { id: 'ReturnableTote', name: 'Returnable Tote' },
  { id: '_1A1', name: 'Steel Drum non-removable head (1A1)' },
];

export const upsCode = [
  { id: '_4G', name: '4G FIBREBOARD BOX' },
  { id: '_3H1', name: 'PLASTIC JERRICAN' },
  { id: '_1H2', name: 'PLASTIC DRUM' },
  { id: '_1N1', name: 'STEEL DRUM' },
  { id: 'NotUnPackaging', name: 'OTHER' },
];
